<template>
  <el-dialog
    title="商品导入完成"
    :visible.sync="dialogVisible"
    width="30%"
    >
    <div class="wrap">
      <div class="total"><span>商品总数：{{self_result.totalNum}}款</span></div>
      <div class="success">
        <div class="left-item">
          <span>成功{{self_result.successNum}}款</span>
          <el-button v-if="self_result.successList && self_result.successList.length" type="link" @click="openTab" style="margin-left:15px">设置商品分销价</el-button>
        </div>
        <div class="right-item" v-if="failedNum">
          <span>失败{{failedNum}}款</span>
          <el-button type="link" style="margin-left:15px" @click="viewReason">查看原因</el-button>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
    </span>
    <!-- 查看原因 -->
    <FailReason ref="failReason"/>
  </el-dialog>
</template>

<script>
import FailReason from './failReason.vue'
export default {
  props: {
    resultData:{
      type: Object,
      default: ()=> {
        return {
          successNum: 0,
          totalNum: 0,
          failedList: []
        }
      }
    },
    outerIds: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    FailReason
  },
  data() {
    return {
      dialogVisible: false,
      self_result: {
        successNum: 0,
        totalNum: 0,
        failedList: []
      }
    }
  },
  watch: {
    resultData(val) {
      if(!val.failedList) {
        val.failedList = []
      }
      this.$set(this, 'self_result', val);
    }
  },
  computed: {
    failedNum() {
      return this.self_result.totalNum - this.self_result.successNum
    }
  },
  methods: {
    method_open() {
      this.dialogVisible = true;
    },
    viewReason() {
      this.$refs.failReason.method_open(this.self_result.failedList);
    },
    openTab() {
      if (!this.self_result.successList || !this.self_result.successList.length) {
        return this.$message.info('无成功数据')
      }
      let outerIds = this.self_result.successList.map(({outerId}) => outerId).join(',');
      const url = `${window.location.origin}/supplier/commodity/myShop?outerIds=${outerIds}`
      window.open(url, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
  .success {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .left-item{
      margin-right: 30px;
    }
  }
</style>
